
import { useAppMeta } from "hooks";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import React from 'react'
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useGetCustomerUserDataDetailQuery, useUpdateCustomerUserDataMutation } from "store/services/customerUserApi";
import CustomerUserForm from "./customerComponents/CustomerUserForm";


const CustomerUserEditScreen = () => {

  const { id } = useParams();

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Customer", path: "/app/crm/customerUser/list" },
    { title: "Edit Customer User" },
  ];

  // RTK Query
  const {
    data: customerUserDetail,
    isLoading: loadingCustomerUser,
    error,
  } = useGetCustomerUserDataDetailQuery(id);


  const [updateCustomer, { isLoading: updatingCustomerUser }] = useUpdateCustomerUserDataMutation();

  // methods
  const handleUpdateCustomerUser = async (data) => {
    
    try {
      await updateCustomer(data).unwrap();
      toast.success("Customer successfully updated!");
      navigate(`/app/crm/customerUser/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update Customer!"
      );
    }
  };
  

  useAppMeta("Edit Customer");
  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingCustomerUser || updatingCustomerUser}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <CustomerUserForm
          customerUserDetail={customerUserDetail}
          isBusy={loadingCustomerUser || updatingCustomerUser}
          onSubmit={handleUpdateCustomerUser}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  )
}

export default CustomerUserEditScreen;